/**
 * StreamsReportSeed entity class
 */

/**
 * StreamsReportSeedFactory
 * returns ReportSeed entity class
 *
 * @class ReportSeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamsReportSeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSeedFactory
 */
/* @ngInject */
// import moment from 'moment/moment'

export default function StreamsReportSeedFactory ($http, Entity, Type, Filter, alertLiteSvc, onOffMixin) {
  /* === StreamsReportSeed class === */

  /**
   * StreamsReportSeed model
   *
   * @class StreamsReportSeed
   * @classdesc StreamsReportSeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamsReportSeed entity fields
   * @return {models.StreamsReportSeed} StreamsReportSeed entity
   */
  function StreamsReportSeed () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamsReportSeed.prototype = Object.create(Entity.prototype)
  StreamsReportSeed.prototype.constructor = StreamsReportSeed

  /* === User instance methods & fields === */

  Object.assign(StreamsReportSeed.prototype, {

    /**
     * All filters list
     */
    _filters: [
      {
        reportElementType: 'STREAM_DATE_FROM_TO',
        abstractFilterValues: []
      },
      {
        reportElementType: 'STREAM_NETWORKS',
        abstractFilterValues: []
      },
      {
        reportElementType: 'STREAM_CHANNELS',
        abstractFilterValues: []
      },
      {
        reportElementType: 'STREAM_PLATFORMS',
        abstractFilterValues: [
          'STB',
          'Others',
          'PC',
          'SamsungTV',
          'iOS',
          'Android',
          'WEB'
        ]
      },
      {
        reportElementType: 'STREAM_REPORTING_METHOD',
        abstractFilterValues: [
          // 'TOP_STREAMING_SUBSCRIBERS',
          'WATCHING_HABITS',
          // 'CURRENT_STREAMS',
          'TOP_REQUESTED_STREAMS',
          // 'WATCHED_TIME',
          'SUBSCRIBER_STREAMING_REPORT',
          'MOST_STREAMED',
          'TOP_WATCHING_SUBSCRIBERS'
        ]
      },
      {
        reportElementType: 'STREAM_TYPE',
        abstractFilterValues: [
          'TV',
          // 'RADIO',
          'VOD'
          // 'CATCHUP'
        ]
      },
      {
        reportElementType: 'REPORT_DISPLAY_MODE',
        abstractFilterValues: [
          'HOUR',
          'DAY',
          'MONTH'
        ]
      },
      {
        reportElementType: 'REPORT_LAYOUT_CHART',
        abstractFilterValues: [
          '10',
          '20',
          '50'
        ],
        abstractFilterValues2: [
          '3',
          '5',
          '10'
        ]
      },
      {
        reportElementType: 'REPORT_LAYOUT_TABLE_LIMIT',
        abstractFilterValues: []
      },
      {
        reportElementType: 'REPORT_TIME_UNIT',
        abstractFilterValues: []
      },
      {
        reportElementType: 'STREAM_SUBSCRIBERS',
        subscriberIds: []
      },
      {
        reportElementType: 'STREAM_DEVICES',
        deviceIds: []
      }
    ],

    /**
     * Dynamic fields structure
     */
    _dynamicFields: [
      {
        fieldName: 'CITY',
        fieldValue: '',
        abstractFilterValues: []
      },
      {
        fieldName: 'COUNTRY',
        fieldValue: null,
        abstractFilterValues: []
      },
      {
        fieldName: 'LANGUAGE',
        fieldValue: null,
        abstractFilterValues: []
      },
      {
        fieldName: 'STATE',
        fieldValue: '',
        abstractFilterValues: []
      },
      {
        fieldName: 'STATUS',
        fieldValue: true,
        abstractFilterValues: []
      },
      {
        fieldName: 'ZIPCODE',
        fieldValue: '',
        abstractFilterValues: []
      },
      {
        fieldName: 'DEVICE_MODEL',
        fieldValue: '',
        abstractValues: []
      },
      {
        fieldName: 'IP_ADDRESS',
        fieldValue: '',
        abstractValues: []
      },
      {
        fieldName: 'ISP',
        fieldValue: '',
        abstractValues: []
      },
      {
        fieldName: 'LOCATION_COUNTRY',
        fieldValue: null,
        abstractValues: []
      },
      {
        fieldName: 'TIMEZONE',
        fieldValue: '',
        abstractValues: []
      }
    ],

    /**
     * instance fields
     *
     * @memberof models.StreamsReportSeed#
     * @type {Object}
     */
    _fields: {
      name: Type(String('')),
      filters: ['Filter'],

      $subscriberFilters: [],
      $deviceFilters: [],

      $filtersList: {}
    },

    /**
     * Function for filter's condition
     *
     * @param key
     * @returns Function
     * @private
     */
    _filterCondition: (key) => {
      const conditions = {
        REPORT_DISPLAY_MODE: (self) =>
          self.$filtersList.STREAM_REPORTING_METHOD.method === 'WATCHING_HABITS',
        REPORT_LAYOUT_TABLE_LIMIT: (self) =>
          self.$filtersList.STREAM_REPORTING_METHOD.method !== 'WATCHING_HABITS',
        STREAM_CHANNELS: (self) =>
          self.$filtersList.STREAM_REPORTING_METHOD.method === 'WATCHING_HABITS' ||
          self.$filtersList.STREAM_REPORTING_METHOD.method === 'TOP_WATCHING_SUBSCRIBERS'
      }
      const result = conditions[key]

      return typeof result === 'function' ? result : () => true
    },

    /**
     * Prepare object
     *
     * @memberof models.StreamsReportSeed#
     * @override
     */
    _prepare: function () {
      this.$filtersList = {}
      for (let i = 0; i < this._filters.length; i++) {
        const filter = this._filters[i]
        this.$filtersList[`${filter.reportElementType}`] = new Filter(filter)
      }
    },

    /**
     * Get underlying object
     *
     * @memberof models.Filter#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.filters = []
      for (const key in this.$filtersList) {
        if (this.$filtersList.hasOwnProperty(key)) {
          this.filters.push(this.$filtersList[key])
        }
      }

      for (let i = 0; i < this.$subscriberFilters.length; i++) {
        this.filters.push(new Filter({ reportElementType: 'STREAM_SUBSCRIBER_FIELD', ...this.$subscriberFilters[i] }))
      }

      for (let i = 0; i < this.$deviceFilters.length; i++) {
        this.filters.push(new Filter({ reportElementType: 'STREAM_DEVICE_FIELD', ...this.$deviceFilters[i] }))
      }

      return Entity.prototype._object.apply(this, arguments)
    },

    /**
     * Search subscriber by param
     *
     * @param {String} searchStr
     * @returns {Promise} promise
     */
    _searchSubscriber: function (searchStr) {
      return $http
        .post('api/reports/streams/extra?subscriber', { searchStr })
        .catch(rejection => alertLiteSvc.alertError(rejection))
    },

    /**
     * Search streams by param
     *
     * @param {String} searchStr
     * @returns {Promise} promise
     */
    _searchStreams: function (searchStr, streamType, networkIds) {
      return $http
        .post('api/reports/streams/extra?stream', { searchStr, streamType, networkIds })
        .catch(rejection => alertLiteSvc.alertError(rejection))
    },

    /**
     * Search devices by param
     *
     * @param {String} searchStr
     * @returns {Promise} promise
     */
    _searchDevices: function (searchStr) {
      return $http
        .post('api/reports/streams/extra?device', { searchStr })
        .catch(rejection => alertLiteSvc.alertError(rejection))
    },

    /**
     * Get fields structure by map list
     *
     * @param maps {Array} - includes values
     * @returns {*[]}
     * @memberof models.Filter#
     */
    _getDynamicFieldsByMap: function (maps) {
      return this._dynamicFields.filter((field) =>
        maps.indexOf(field.fieldName) !== -1)
    },

    /**
     * Set values to dynamic fields
     *
     * @param type {String} - dynamicFields[].fieldName value
     * @param values {Array} - set to dynamicFields[].abstractValues
     * @memberof models.Filter#
     */
    _setAbstractValues: function (type, values) {
      const index = this._dynamicFields.findIndex((item) =>
        item.fieldName === type)

      this._dynamicFields[index].abstractFilterValues = values
    }

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamsReportSeed, Entity)
  StreamsReportSeed._name = 'StreamsReportSeed'
  StreamsReportSeed.init()

  // permissions
  // StreamsReportSeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return StreamsReportSeed
}
